import { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import calendarService from '../services/calendarService';
import seasonModelService from '../services/seasonModelService';
import seasonPriceService from '../services/seasonPriceService';
import seasonService from '../services/seasonService';
import vehicleModelService from '../services/vehicleModelService';

const useServices = () => {
  const { authenticatedFetch } = useAuth();

  useEffect(() => {
    console.log('🔧 useServices: Inicializando servicios...', { authenticatedFetch: !!authenticatedFetch });
    
    // Inicializar todos los servicios con la función de fetch autenticada
    if (authenticatedFetch) {
      console.log('✅ useServices: Configurando servicios con authenticatedFetch');
      seasonService.setAuthenticatedFetch(authenticatedFetch);
      seasonPriceService.setAuthenticatedFetch(authenticatedFetch);
      seasonModelService.setAuthenticatedFetch(authenticatedFetch);
      vehicleModelService.setAuthenticatedFetch(authenticatedFetch);
      calendarService.setAuthenticatedFetch(authenticatedFetch);
    } else {
      console.log('❌ useServices: authenticatedFetch no disponible');
    }
  }, [authenticatedFetch]);

  return {
    seasonService,
    seasonPriceService,
    seasonModelService,
    vehicleModelService,
    calendarService
  };
};

export default useServices;
